import React from "react";
import {
  useTheme,
  Container,
  Typography,
  Box,
  Divider,
  Link,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import darkTheme from "./theme";

function App() {
  const theme = useTheme();

  return (
    <ThemeProvider theme={darkTheme}>
      <Container
        sx={{ backgroundColor: "transparent", padding: "2em" }}
        maxWidth="m"
      >
        <Box sx={{ my: 4 }}>
          <Box
            sx={{
              width: "100%",
              height: "auto",
              minHeight: "80px",
              marginBottom: "1em",
              backgroundImage: "url(mnml.png)",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></Box>
          <Typography
            sx={{
              fontSize: "1.25em",
              fontFamily: "Jetbrains Mono",
              textTransform: "uppercase",
              textAlign: "center",
              letterSpacing: "4px",
              wordSpacing: "-16px",
              userSelect: "none",
              [theme.breakpoints.down("sm")]: {
                fontSize: "1.0em",
              },
            }}
          >
            minimal<span style={{ color: "gray" }}>|</span> intelligence
          </Typography>

          <Divider
            style={{
              margin: "1em 0 2em 0",
            }}
          />
          <Link
            href="https://genflow.run"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box
              sx={{
                width: "100%",
                height: "auto",
                minHeight: "300px",
                marginBottom: "1em",
                backgroundImage: "url(genflow_screen_04.jpg)",
                backgroundSize: "cover",
                backgroundPosition: "left top",
                backgroundRepeat: "no-repeat",
                [theme.breakpoints.down("sm")]: {
                  width: "calc(100% + 4em)",
                  margin: "-2em 0 1em -2em",
                  padding: "0",
                  minHeight: "300px",
                  backgroundSize: "fit",
                },
              }}
            ></Box>
          </Link>
          <Typography variant="h5">
            we are building a node-based environment for generative machine
            learning.
          </Typography>

          <Typography variant="body2">
            still in alpha - for friends and early testers
          </Typography>

          <Divider
            style={{
              margin: "1em 0 2em 0",
            }}
          />
        </Box>
        <Typography
          sx={{
            color: (theme) => theme.palette.primary.main,
            // textTransform: "uppercase",
            padding: "1em 0",
            fontSize: "1.25em",
            width: "fit-content",
          }}
        >
          hello@minimalintelligence.com
        </Typography>
      </Container>
    </ThemeProvider>
  );
}

export default App;
